import React from "react";
import { useFormikContext } from "formik";
import Select from "components/Form/fields/Select";
import get from "lodash/get";

const EditorSelect = ({ label, options, name }) => {
  const {
    values,
    setFieldTouched,
    setFieldValue,
    touched
  } = useFormikContext();

  const selectProps = {
    options,
    stateKey: name,
    value: get(values, name),
    onChange: (key) => (evt) => {
      const selection = evt.currentTarget.value;
      setFieldValue(key, selection);
      if (!get(touched, name)) {
        setFieldTouched(key, true);
      }
    },
    labelTransform: (val) => {
      return val;
    },
    customClasses: {
      container: "relative h-100",
      input:
        "border-box input-reset ba b--black-20 pa2 mb0 db w-100 pv2 f6 br2 h-100"
    }
  };

  return (
    <div className="flex flex-row w-100 justify-between items-center">
      <div className="f6">{label}</div>
      <div className="h-100 w-60">
        <Select {...selectProps} />
      </div>
    </div>
  );
};

export default EditorSelect;
